var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHyperlink = function SvgHyperlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.836 17.837 5-5a.938.938 0 0 1 1.532 1.024.94.94 0 0 1-.204.305l-5 5a.94.94 0 0 1-1.328-1.329ZM23.07 8.931a4.694 4.694 0 0 0-6.63 0l-2.353 2.351a.94.94 0 0 0 1.328 1.328l2.349-2.348a2.813 2.813 0 1 1 3.979 3.978l-2.352 2.347a.938.938 0 0 0 1.023 1.532.94.94 0 0 0 .305-.203l2.35-2.349a4.694 4.694 0 0 0-.003-6.633l.004-.003Zm-6.483 10.46-2.349 2.35a2.812 2.812 0 1 1-3.978-3.98l2.348-2.348a.94.94 0 0 0-.304-1.532.94.94 0 0 0-1.024.203l-2.346 2.352a4.688 4.688 0 1 0 6.63 6.63l2.35-2.349a.94.94 0 1 0-1.329-1.328l.002.002Z"
  })));
};
export default SvgHyperlink;